import { Injectable } from '@angular/core';
import { dbConst } from './databaseConstants';
import { FirestoreCrudService } from './crudService';
import { AuthService } from '../auth.service';
import { Firestore } from '@angular/fire/firestore';
import { IBottle } from 'app/models/bottle';
import { Store } from '@ngrx/store';
import { IOnTapTvActiveDisplay } from 'app/models/ontapTvActiveDisplays';

@Injectable({
  providedIn: 'root'
})
export class OntapTvActiveDisplayService {
  private crudService: FirestoreCrudService<IOnTapTvActiveDisplay>;
  constructor(
    firestore: Firestore,
    authService: AuthService) {
    this.crudService = new FirestoreCrudService<IOnTapTvActiveDisplay>(firestore, authService, dbConst.ontapTvActiveDisplays);
  }

  public getNewId() {
    return this.crudService.getNewId();
  }

  async add(item: IOnTapTvActiveDisplay, id: string = "") {
    if (id === "") {
      id = this.crudService.getNewId();
    }


    const newItem = await this.crudService.add(item, id);

    return newItem;
  }

  async update(item: IOnTapTvActiveDisplay) {
    return await this.crudService.update(item);
  }

  async delete(id: string) {
    if (id)
      await this.crudService.delete(id);
  }

  getItem(id: string) {
    return this.crudService.get(id)
  }

  getItems(barId: string) {
    return this.crudService.getItems(barId);
  }


  getItemsPromise(barId: string) {
    return this.crudService.getItemsOnce(barId, "name", 100);
  }

  async softUpdate(id: string, item: any, uid: string) {
    return await this.crudService.softUpdate(id, item, uid);
  }

}
